import type HttpClient from "../../tastyworks/http"
import {
  PROMOTIONAL_CODE_DESER,
  PromotionalCode,
} from "../../tastyworks/promotional-code"

export class PromotionalCodeService {
  constructor(private readonly accountNumberClient: HttpClient) {}

  readonly create = async (
    promotionalCode: PromotionalCode,
    accountNumber: string
  ) =>
    this.accountNumberClient.create(
      promotionalCode,
      PROMOTIONAL_CODE_DESER.serialize,
      PROMOTIONAL_CODE_DESER.update,
      "promotional-codes",
      { accountNumber }
    )
}
